var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
import withBranding from "@irati/brand/withBranding";
import { brand } from "@irati/ui/src/global/colors";
import { getImageSize } from "@irati/utils/images/getImageSize/getImageSize";
import Card from "@irati/ui/src/Layout/Card";
import { ShadowCard } from "@irati/ui/src/Layout";
import { injectIntl } from "@irati/utils/lang";
import { determineDealColor, determineDealThumbnailImage } from "@irati/deals/helpers/deals/appearance";
import { COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS } from "@irati/deals/constants/dealType";
import BrandAvatar from "@irati/ui/src/BrandAvatar";
import FullWidthBanner from "../ui/FullWidthBanner/FullWidthBanner";
import ContinueButton from "./ContinueButton";
import OrderSummary from "../../containers/OrderSummary";
import "./styles/ProductLayout.css";
var ContinueMobile = styled(ContinueButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
var Continue = styled(ContinueButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 30px;\n"], ["\n  margin-top: 30px;\n"])));
var ProductLayout = /** @class */ (function (_super) {
    __extends(ProductLayout, _super);
    function ProductLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getBannerImageColor = function (isCompanyBenefit) {
            var businessLogoUrl = _this.props.branding.businessLogoUrl;
            var brandColor = determineDealColor(_this.props.deal, businessLogoUrl, brand.default);
            return isCompanyBenefit ? brandColor : null;
        };
        return _this;
    }
    ProductLayout.prototype.render = function () {
        var _a = this.props, email = _a.email, deal = _a.deal, walletBalanceToUse = _a.walletBalanceToUse, onClick = _a.onClick, disabled = _a.disabled, loading = _a.loading, buttonText = _a.buttonText, formatMessage = _a.formatMessage, branding = _a.branding;
        var orderSummaryProps = { email: email, deal: deal, walletBalanceToUse: walletBalanceToUse, onClick: onClick };
        var continueButtonProps = { disabled: disabled, loading: loading, onClick: onClick, buttonText: buttonText };
        var isCompanyBenefit = this.props.deal.type === DEAL_TYPE_COMPANY_BENEFITS;
        var bannerImageSrc = isCompanyBenefit ? null : getImageSize(deal.bannerImage, 1600, 400);
        var bannerImageColor = this.getBannerImageColor(isCompanyBenefit);
        var thumbnailImageSrc = determineDealThumbnailImage(this.props.deal, branding);
        return (React.createElement("div", { className: "productLayout" },
            React.createElement(FullWidthBanner, { src: bannerImageSrc, color: bannerImageColor, alt: formatMessage({ id: "perks.components.productForms.productLayout.alt" }), useImgTag: false }),
            React.createElement("div", { className: "productLayout_wrapper" },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, smHidden: true, mdHidden: true, lgHidden: true },
                        React.createElement(Card, { className: "card--top-offset", style: { marginBottom: "5px" } },
                            React.createElement(BrandAvatar, { src: thumbnailImageSrc }),
                            React.createElement(OrderSummary, __assign({}, orderSummaryProps, { isMobile: true })))),
                    React.createElement(Col, { xs: 12, sm: 7, md: 6, mdOffset: 1, className: "clearfix" },
                        React.createElement(ShadowCard, { large: true },
                            this.props.children,
                            !this.props.continueHidden && (React.createElement(Row, null,
                                React.createElement(Col, { xs: 12, smHidden: true, mdHidden: true, lgHidden: true },
                                    React.createElement(ContinueMobile, __assign({}, continueButtonProps, { id: "continue_mobile" }))))))),
                    React.createElement(Col, { sm: 5, md: 4, xsHidden: true },
                        React.createElement(Card, null,
                            React.createElement(BrandAvatar, { src: thumbnailImageSrc }),
                            React.createElement(OrderSummary, __assign({}, orderSummaryProps)),
                            !this.props.continueHidden && React.createElement(Continue, __assign({}, continueButtonProps))))))));
    };
    ProductLayout.defaultProps = {
        disabled: false,
        continueHidden: false,
        email: null,
        loading: null,
        buttonText: null,
        walletBalanceToUse: 0
    };
    return ProductLayout;
}(Component));
export default injectIntl(withBranding(ProductLayout));
var templateObject_1, templateObject_2;
